import { Helmet } from 'react-helmet';
import Navbar from '../../components/light/creative-agency/Navbar';
import Footer from '../../components/light/creative-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import { Link } from 'react-router-dom';
import AiExploreBar from '../../components/light/ai/AiExploreBar';
import AiVideoCard from '../../components/light/ai/AiVideoCard';
import AiImageCard from '../../components/light/ai/AiImageCard';
import '../../components/light/ai/aiStyles.css';

const videosPreview = [
  'icecream.mp4',
  'icecream2.mp4',
  'earings.mp4',
].map((fileName) => ({
  fileName,
  src: `/light/assets/ai/Videos/${fileName}`,
}));

const modelPreview = [
  '1.jpg',
  '2.jpg',
  'Indian_female_model_in_her_202605151737.jpeg',
].map((fileName) => ({
  fileName,
  src: `/light/assets/ai/Model Shoot/${encodeURIComponent(fileName)}`,
}));

const productPreview = [
  '3.jpg',
  '6.jpg',
  'gold_necklace_and_earrings_displayed_202605151736.jpeg',
].map((fileName) => ({
  fileName,
  src: `/light/assets/ai/Product Shoot/${encodeURIComponent(fileName)}`,
}));

export default function PageAi() {
  return (
    <>
      <Helmet>
        <title>Aashway | AI Creative Services</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              {/* Header section matching other service layouts */}
              <div
                className="header page-header bg-img section-padding"
                data-background="/light/assets/imgs/header/b5.jpg"
                data-overlay-dark="9"
                style={{ backgroundImage: 'url("/light/assets/imgs/header/b5.jpg")' }}
              >
                <div className="container pt-100">
                  <div className="text-center">
                    <h1 className="fz-100 text-u">AI Creative Services</h1>
                    <div className="mt-15">
                      <a href="/">Home</a>
                      <span className="padding-rl-20">|</span>
                      <span className="main-color">AI</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub-navigation bar */}
              <div className="container mt-40">
                <AiExploreBar active="ai" />
              </div>

              {/* AI Sections Overview */}
              <section className="ai-section-wrap pt-40">
                <div className="container">
                  {/* AI Videos Section */}
                  <div className="ai-section-block">
                    <div className="sec-head mb-40">
                      <h6 className="sub-title main-color mb-15">Motion Content</h6>
                      <div className="bord pt-15 bord-thin-top d-flex align-items-center">
                        <h2 className="fw-600 text-u ls1">
                          AI <span className="fw-200">Videos</span>
                        </h2>
                      </div>
                    </div>
                    <div className="ai-gallery">
                      {videosPreview.map((v) => (
                        <AiVideoCard key={v.src} src={v.src} fileName={v.fileName} />
                      ))}
                    </div>
                    <div className="ai-explore-btn-wrap">
                      <Link to="/light/page-ai-videos" className="btn btn-primary ai-btn">
                        Explore All Videos
                      </Link>
                    </div>
                  </div>

                  <hr className="bord-thin-top my-5" style={{ opacity: 0.1 }} />

                  {/* AI Model Shoot Section */}
                  <div className="ai-section-block">
                    <div className="sec-head mb-40">
                      <h6 className="sub-title main-color mb-15">Fashion & Editorial</h6>
                      <div className="bord pt-15 bord-thin-top d-flex align-items-center">
                        <h2 className="fw-600 text-u ls1">
                          AI <span className="fw-200">Model Shoot</span>
                        </h2>
                      </div>
                    </div>
                    <div className="ai-gallery">
                      {modelPreview.map((img) => (
                        <AiImageCard key={img.src} src={img.src} fileName={img.fileName} />
                      ))}
                    </div>
                    <div className="ai-explore-btn-wrap">
                      <Link to="/light/page-ai-model-shoot" className="btn btn-primary ai-btn">
                        Explore Model Shoot
                      </Link>
                    </div>
                  </div>

                  <hr className="bord-thin-top my-5" style={{ opacity: 0.1 }} />

                  {/* AI Product Shoot Section */}
                  <div className="ai-section-block">
                    <div className="sec-head mb-40">
                      <h6 className="sub-title main-color mb-15">E-Commerce & Branding</h6>
                      <div className="bord pt-15 bord-thin-top d-flex align-items-center">
                        <h2 className="fw-600 text-u ls1">
                          AI <span className="fw-200">Product Shoot</span>
                        </h2>
                      </div>
                    </div>
                    <div className="ai-gallery">
                      {productPreview.map((img) => (
                        <AiImageCard key={img.src} src={img.src} fileName={img.fileName} />
                      ))}
                    </div>
                    <div className="ai-explore-btn-wrap">
                      <Link to="/light/page-ai-product-shoot" className="btn btn-primary ai-btn">
                        Explore Product Shoot
                      </Link>
                    </div>
                  </div>

                </div>
              </section>
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}


